import request from '../helpers/request';

const updateCalendarEvent = async (eventId, data, dataPlaceholder = null) => {
  const { workerId, requestId, fromDate, toDate } = data;

  return await request.put(
    `/Request/edit_task/${eventId}`,
    { workerId, requestId, fromDate, toDate },
    'Не удалось изменить дату события в календаре',
    dataPlaceholder
  );
};

export default updateCalendarEvent;
